import { formatMonthLabel, stepMonth, currentYearMonth } from './format'

interface Props {
  year: number
  month: number
  onChange: (year: number, month: number) => void
}

export function MonthPicker({ year, month, onChange }: Props) {
  const today = currentYearMonth()
  const isToday = year === today.year && month === today.month

  return (
    <div className="flex items-center gap-2" role="group" aria-label="Budget month">
      <button
        type="button"
        onClick={() => {
          const next = stepMonth(year, month, -1)
          onChange(next.year, next.month)
        }}
        aria-label="Previous month"
        className="rounded-md border border-zinc-300 px-2 py-1 hover:bg-zinc-100 dark:border-zinc-700 dark:hover:bg-zinc-800"
      >
        ←
      </button>

      <div className="min-w-[180px] text-center text-lg font-semibold" aria-live="polite">
        {formatMonthLabel(year, month)}
      </div>

      <button
        type="button"
        onClick={() => {
          const next = stepMonth(year, month, 1)
          onChange(next.year, next.month)
        }}
        aria-label="Next month"
        className="rounded-md border border-zinc-300 px-2 py-1 hover:bg-zinc-100 dark:border-zinc-700 dark:hover:bg-zinc-800"
      >
        →
      </button>

      {!isToday && (
        <button
          type="button"
          onClick={() => onChange(today.year, today.month)}
          className="rounded-md border border-zinc-300 px-3 py-1 text-sm hover:bg-zinc-100 dark:border-zinc-700 dark:hover:bg-zinc-800"
        >
          Today
        </button>
      )}
    </div>
  )
}
